import type { TFunction } from 'i18next';
import type { ValidationError } from './validationErrors';

/**
 * Check if the browser is offline and show a validation error if so.
 * Returns true if offline (caller should abort the save).
 *
 * Used by generated detail views to block saves when offline
 * while keeping form data intact.
 */
export function checkOfflineAndNotify(
  setErrors: (errors: ValidationError[]) => void,
  setPanel: (open: boolean) => void,
  t: TFunction,
): boolean {
  if (!navigator.onLine) {
    setErrors([{
      field: 'form',
      message: t('error.offline'),
      instancePath: '#/properties/form',
      members: ['form'],
    }]);
    setPanel(true);
    return true;
  }
  return false;
}
